(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yl-first-order-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yl-first-order-coupon')) {
    customElements.define('yl-first-order-coupon', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.claim = this.querySelector('[data-offer-claim]');
        this.label = this.querySelector('[data-offer-label]');
        this.defaultLabel = this.label.textContent;
        this.dialog = this.querySelector('dialog');
        this.status = this.querySelector('[data-offer-status]');
        this.retry = this.querySelector('[data-offer-retry]');
        this.save = this.querySelector('[data-offer-save]');
        this.claim.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.dialog.showModal();
          this.saveCode();
        });
        this.querySelector('[data-offer-terms]').addEventListener('click', () => {
          this.save.hidden = false;
          this.dialog.showModal();
        });
        this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => this.claim.focus({ preventScroll: true }));
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.retry.addEventListener('click', () => this.saveCode());
        this.save.addEventListener('click', () => this.saveCode());
        this.querySelector('[data-offer-copy]').addEventListener('click', async () => {
          const result = this.querySelector('[data-offer-copy-status]');
          try { await navigator.clipboard.writeText(this.dataset.code); result.textContent = this.dataset.copied; }
          catch { result.textContent = this.dataset.copyError; }
        });
      }
      async saveCode() {
        if (this.busy) return;
        this.busy = true;
        this.retry.hidden = true;
        this.save.hidden = true;
        this.dialog.dataset.state = 'saving';
        this.status.textContent = this.dataset.loading;
        this.claim.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: this.dataset.code }), signal: controller.signal
          });
          if (!response.ok) throw new Error('Discount request failed');
          const cart = await response.json();
          if (!Array.isArray(cart.items) || typeof cart.item_count !== 'number') throw new Error('Invalid cart response');
          if (Array.isArray(cart.discount_codes) && !cart.discount_codes.some(d => d.code.toUpperCase() === this.dataset.code.toUpperCase())) throw new Error('Discount not saved');
          document.querySelectorAll('yl-first-order-coupon').forEach(offer => {
            if (offer !== this && offer.label) offer.label.textContent = offer.defaultLabel;
          });
          this.dialog.dataset.state = 'saved';
          this.status.textContent = this.dataset.success;
          this.label.textContent = this.dataset.savedLabel;
          document.dispatchEvent(new CustomEvent('yl:offer-saved', { detail: { code: this.dataset.code } }));
        } catch {
          this.dialog.dataset.state = 'error';
          this.status.textContent = this.dataset.error;
          this.retry.hidden = false;
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.claim.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yl-food-welcome-ticket"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yl-food-ticket')) {
    customElements.define('yl-food-ticket', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.launcher = this.querySelector('.yl-food-ticket__launcher');
        this.claim = this.querySelector('[data-ticket-claim]');
        this.status = this.querySelector('[data-ticket-status]');
        this.launcher.hidden = false;
        this.launcher.addEventListener('click', () => this.openTicket());
        this.querySelectorAll('[data-ticket-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => {
          try { sessionStorage.setItem('yl-food-ticket-dismissed-v1', '1'); } catch {}
          this.launcher.focus({ preventScroll: true });
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.claim.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.saveOffer();
        });
        const form = this.querySelector('form');
        form.addEventListener('submit', event => {
          if (!this.querySelector('#YlFoodConsent').checked || !form.reportValidity()) event.preventDefault();
        });
        if (this.querySelector('[data-ticket-form-result]')) {
          this.querySelector('.yl-food-ticket__email').open = true;
          this.openTicket();
        } else {
          let dismissed = false;
          try { dismissed = sessionStorage.getItem('yl-food-ticket-dismissed-v1') === '1'; } catch {}
          if (!dismissed) this.timer = setTimeout(() => {
            if (document.visibilityState === 'visible' && !document.querySelector('dialog[open]') && !document.activeElement?.matches('input, textarea, select')) this.openTicket();
          }, 8000);
        }
      }
      openTicket() {
        clearTimeout(this.timer);
        if (!this.dialog.open) this.dialog.showModal();
      }
      disconnectedCallback() { clearTimeout(this.timer); }
      async saveOffer() {
        if (this.busy) return;
        this.busy = true;
        this.claim.setAttribute('aria-busy', 'true');
        this.dialog.dataset.state = 'saving';
        this.status.textContent = this.dataset.loading;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: this.dataset.code }), signal: controller.signal
          });
          if (!response.ok) throw new Error('Discount save failed');
          const cart = await response.json();
          if (!Array.isArray(cart.items) || typeof cart.item_count !== 'number') throw new Error('Invalid cart response');
          if (!Array.isArray(cart.discount_codes) || !cart.discount_codes.some(item => String(item.code).toUpperCase() === this.dataset.code)) throw new Error('Discount missing');
          this.dialog.dataset.state = 'saved';
          this.status.textContent = this.dataset.saved;
          this.querySelector('[data-ticket-code]').hidden = false;
          document.dispatchEvent(new CustomEvent('yl:offer-saved', { detail: { code: this.dataset.code } }));
        } catch {
          this.dialog.dataset.state = 'error';
          this.status.textContent = this.dataset.error;
          this.querySelector('[data-ticket-code]').hidden = false;
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.claim.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
